import axios from 'axios'
const base_url =  `${process.env.VUE_APP_API_PATH}`;

export default {
    login(payload) {
        const url = `${base_url}/authenticate/login`;
        return axios.post(url, payload)
    }
}

//
// function login() {
//
//
//     fetch(apiPath + '/authenticate/login', {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify({
//             "email": this.state.email.toString(),
//             "password": this.state.password.toString(),
//         })
//     }).then((response) => {
//         if (response.ok) {
//             response.json().then(responseJson => {
//                 if (responseJson.role !== 'USER') {
//                     document.cookie = 'UserStatus=' + responseJson.role;
//                     document.cookie = 'Employee=' + this.state.email;
//                     document.cookie = 'authToken=' + responseJson.authToken;
//                     headerWithToken.Authorization = 'Bearer ' + responseJson.authToken;
//                     localStorage.setItem("UserStatus", responseJson.role);
//                     localStorage.setItem('Employee', this.state.email);
//                     localStorage.setItem("authToken", responseJson.authToken);
//                     this.props.history.push("/dashboard")
//                 } else {
//                     this.setState({error: true, errorMessage: 'Unauthorized check email or password'});
//                 }
//             })
//
//         } else {
//             response.json().then(() => {
//                 this.setState({error: true, errorMessage: 'Unauthorized check email or password'});
//             })
//         }
//     }).catch((error) => this.setState({
//         error: true,
//         errorMessage: 'Try again later'
//     })).finally(() => this.setState({loading: false}))
// }
// ;
